import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'mf-right-sidebar',
  templateUrl: './right-sidebar.component.html',
  styleUrls: ['./right-sidebar.component.scss'],
})
export class RightSidebarComponent {}
